import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { colors } from '../../styles/colors'

const Container = styled.div`
    position: relative;

    * {
        transition: all .25s;
    }

    .qtty {
        width: 3rem;
        height: 3rem;

        background: ${colors.red};
        border-radius: 50%;

        display: flex;
        align-items: center;
        justify-content: center;

        font-family: 'SF UI Text Regular', sans-serif;
        font-size: 2.25rem;

        position: absolute;
        bottom: -.5rem;
        right: -1rem;

    }

    :hover {
        .qtty {
            background: ${colors.dark_blue};
            color: ${colors.white};
        }
        svg path {
            stroke: ${colors.red};
        }
    }
`

export const CartIco = () => {

    const goods = useSelector(state => state.cart.length)


    return (
        <Container className="cart-ico">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.5 8.84475H3C2.44772 8.84475 2 9.29247 2 9.84475V31C2 31.5523 2.44772 32 3 32H31C31.5523 32 32 31.5523 32 31V9.84475C32 9.29247 31.5523 8.84475 31 8.84475H24.5M9.5 8.84475V3C9.5 2.44771 9.94772 2 10.5 2H13.25H23.5C24.0523 2 24.5 2.44772 24.5 3V8.84475M9.5 8.84475H24.5" stroke="#00253D" strokeWidth="2.5" />
            </svg>
            { goods !== 0
                ? <div className="qtty"> {goods} </div>
                : null
            }
        </Container>
    )
}